import { useState } from 'react';

export default function MiniSearchBox() {
    const [searchValue, setSearchvalue] = useState('');

    const changeHandler = (e) => {
        setSearchvalue(e.target.value);
    }

    const keyPress = (e) => {
        if(e.key == 'Enter') {
           submitSearch();
        }
     }

    const submitSearch = (e) => {
        if (e) {
            e.preventDefault();
        }
        window.location = `/search/all/${encodeURI(searchValue)}`;
    }

    return <>
        <div className="input-field ajb-col-9 ajb-col-5-breakpoint margin-top-0 margin-left-0">
            <i className="fas fa-search prefix" />
            <input className="margin-bottom-10 margin-bottom-20-sm"
                id="icon_prefix"
                type="text"
                placeholder="Search"
                value={searchValue}
                onChange={changeHandler}
                onKeyDown={keyPress}
            />
        </div>
        <span className="input-group-btn ajb-col-3 ajb-col-3-breakpoint padding-top-10">
            <input className="form-submit c-btn c-btn-smaller button-default waves-effect waves-light button button--red" type="submit" value="Search" onClick={submitSearch} data-testid="formSubmitInput" />
        </span>
    </>;
}